import script from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomButton.vue?vue&type=script&lang=ts&setup=true"

import "./AtomButton.vue?vue&type=style&index=0&id=d4287052&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4287052"]])

export default __exports__